import { PriceSettingsTab } from '../../containers/PriceSettingsContent/PriceSettingsNavigator'

export default {
  finishDate: new Date(),
  hint: {
    anchorEl: {
      current: undefined,
    },
    block: false,
    date: null,
    extraBed: false,
    finishDate: new Date(),
    open: false,
    prices: {},
    restrictions: {},
    roomSize: 0,
    startDate: new Date(),
  },
  onboardCalendarModal: true,
  onboardModal: true,
  onboardPriceModal: true,
  loadingGlobal: false,
  prices: [],
  selectedDate: null,
  startDate: new Date(),
  priceSettingsTab: PriceSettingsTab.None,
  diff: false,
  settingsData: {},
  closeModal: false,
  action: '',
  errors: false,
  feeModal: false,
  expanded: [],
  newPrices: [],
  newPricesLoading: false,
  editRoomOpen: false,
  editRoomId: undefined,
  roomSettings: undefined,
  editRoomPrice: false,
  airbnbSettingsErrors: {},
  bookingSettingsErrors: {},
  roomSettingsGlobal: [],
  provisionPopout: false,
  roomsExpanded: true,
  scroll: {
    clientWidth: 0,
    scrollLeft: 0,
    scrollWidth: 0,
  },
  priceGridFilter: {
    channels: { airbnb: false, bedbooking: false, booking: false },
    capacities: {},
  },
  copyPricesFinished: false,
  copyPricesError: null as string | null,
}
